import { IComponentOptions } from "angular";
import { MachinesMoveViewController } from "./controller";

export const vsComponentName = "machinesMoveView";

export const MachinesMoveViewComponentOptions: IComponentOptions = {
  controller: MachinesMoveViewController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machineConfigurations: "<",
  },
};
